
import { BaseYcState, RegisterYCState } from '@yourcause/common/state';
import { BudgetAssignmentApplicationHistory, BudgetAssignmentRuleSetDetail, SimpleBudgetAssignmentRuleSet } from './budget-assignments.typing';
import { TableDataFactory } from '@yourcause/common';

@RegisterYCState()
export class BudgetAssignmentsState extends BaseYcState {
  readonly detailMap: Record<number, BudgetAssignmentRuleSetDetail> = {};
  readonly ruleSetDataFactory: TableDataFactory<SimpleBudgetAssignmentRuleSet>;
  readonly historyDataFactory: TableDataFactory<BudgetAssignmentApplicationHistory>;
}

